<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fmh" id="epi"><a id="_idTextAnchor000"></a><a href="#/text/9780062652874_Contents#repi"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii">Epigraph</span></a></h2>
<p class="poem_split"><i>Far above the crown of stars,</i></p>
<p class="poem"><i>there lay a kingdom cast in shadows</i></p>
<p class="poem"><i>until a daughter born of light</i></p>
<p class="poem"><i>drove the night away.</i></p>
<p class="poem"><i>And so the Great Dark waited</i></p>
<p class="poem"><i>a thousand turns around the sun</i></p>
<p class="poem"><i>and promised on its heart of iron</i></p>
<p class="poem"><i>to once again return.</i></p>
<p class="poem">—“Origin of the Moon Goddess,”</p>
<p class="poem"><i>The Cantos of Light</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062652874_Epigrph.vue?36469e05